import React, {useState, useEffect} from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Model from '../../../../model';
import Page from '../../../pages/Page';
import { observer } from 'mobx-react-lite';
import './index.sass';
import IFrame from 'components/IFrame';

const {cnBlock, el} = bem('nepapina-dochka-materials');

const itemName1 = 'Запись вебинара Вероники Сидоровой «Не/папина дочка»';
const itemName2 = 'Вебинар Вероники Сидоровой «Не/папина дочка»';
const title = itemName2;
const NePapinaDochkaMaterials = () => {

    const { user } = Model;
    const [ loading, setLoading ] = useState(false);
    const [ item, setItem ] = useState(null);

    useEffect(() => {
        setLoading(true);
        user.getDigital(itemName1)
            .then((digital) => {
                if (digital === undefined) {
                    return user.getDigital(itemName2)
                }
                return digital;
            })
            .then((digital) => {
                setLoading(false);
                if (digital !== undefined) {
                    setItem(digital);
                }
            })
            .catch((error) => {
                setLoading(false)
                console.log(error);
            });
    }, []);

    if (loading) {
        return <Page className={ cnBlock() } title={ title } loading={ loading }/>
    }

    if (!item) {
        return <Page className={ cnBlock() } title={ title }>
            <div className={ el('content') }>
                <div className={ el('info') }>
                    <Text>{ `Курс не был приобретен для пользователя ${ user.username }` }</Text>
                </div>
            </div>
        </Page>
    }

    const files = item?.digital?.files
        .filter(file => !!file.isActive);

    if (files.length === 0) {
        return <Page className={ cnBlock() } title={ title }>
            <div className={ el('content') }>
                <div className={ el('info') }>
                    <Text>{ `Курс не содержит материалов` }</Text>
                </div>
            </div>
        </Page>;
    }

    return (
        <Page className={ cnBlock() } title={ title } >
            <div className={ el('video') }>
                <IFrame src={files[0].urlIframe} />
            </div>
        </Page>
    )
};

export default observer(NePapinaDochkaMaterials);
